import PriceChart from "./PriceChart";
import {
  LakersLogoL,
  DenverNuggets,
  ShootingBasketball,
  TotalBalance,
} from "../assets/img";

const teamsStats = [
  {
    name: "Lakers",
    change: "+2.05",
    date: "Today",
    image: LakersLogoL,
    bgColor: "bg-[#F0B90B]",
  },
  {
    name: "Sun",
    change: "+3.05",
    date: "2 Days Ago",
    image: ShootingBasketball,
    bgColor: "bg-secondary",
  },
  {
    name: "Nuggets",
    change: "+1.05",
    date: "3 Days Ago",
    image: DenverNuggets,
    bgColor: "bg-[#FACC15]",
  },
  {
    name: "Nuggets",
    change: "+1.90",
    date: "5 Days Ago",
    image: DenverNuggets,
    bgColor: "bg-[#FACC15]",
  },
];

export default function AccountBalance() {
  return (
    <>
      <section className="flex-1 min-h-[576px] w-full grid grid-cols-6 px-5 gap-4 py-8 border-[#BFBFBF] border rounded-xl shadow-custom3">
        <div className="h-80 col-span-6 lg:col-span-4 rounded-md shadow-custom3 p-4 border border-[#BFBFBF]">
          <div className="flex items-center justify-between">
            <p className="mb-3 flex items-center justify-start gap-2 text-lg text-black font-semibold">
              <TotalBalance /> Total Balance
            </p>
            <div className="border border-[#C4CDD5] text-[#919EAB] text-xs rounded flex items-center justify-center gap-2 px-2 py-1">
              <p>Today</p>
              <span>▼</span>
            </div>
          </div>
          <div className="h-full">
            <PriceChart
              gradientStart="rgba(250, 204, 21, 1)"
              gradientEnd="rgba(250, 204, 21, 0.02)"
              lineColor="#FACC15"
              pointerIndex={4}
              pointerColor="#000"
            />
          </div>
        </div>
        <div className="col-span-6 lg:col-span-2 flex flex-col gap-4 rounded-md shadow-custom3 p-4 border border-[#BFBFBF] h-80">
          {teamsStats?.map(({ name, image, change, date, bgColor }) => {
            return (
              <div className="flex items-center justify-between gap-y-4">
                <div className="flex items-center justify-between gap-3">
                  <div
                    className={`w-12 h-[44.56px] flex items-center rounded justify-center ${bgColor}`}
                  >
                    <img src={image} alt="logo" className="h-7 w-7" />
                  </div>
                  <div>
                    <h3 className="font-medium text-sm">{name}</h3>
                    <p className="text-[#919EAB] text-xs">{date}</p>
                  </div>
                </div>
                <div>
                  <p
                    className={`${
                      name === "Lakers" ? "text-[#6DD64D]" : "text-[#FF4842]"
                    }`}
                  >
                    {change}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
